module.exports = __webpack_public_path__ + "static/media/object-group.469a47c3.svg";